import { useState } from "react";
import { ICampaignFormState, IPaginationRequest } from "../../Typings/Campaigns";
import { Rule } from "../../Typings/DynamicGroupRules";
import FilterModal from "../../../CampaignProfile/Components/CandidatesCaptured/FilterModal";
import CandidatesCapturedSearchInput from "../../../CampaignProfile/Components/CandidatesCaptured/CandidatesCapturedSearchInput";
import { FieldType } from "../../../DynamicGroup/DynamicGroup";
import { Grid } from "@mui/material";
import CandidatesCapturedFilters from "../../../CampaignProfile/Components/CandidatesCaptured/CandidatesCapturedFilters";
import { IGroup } from "../../Typings/Groups";

interface DynamicSearchComponentProps {
  paginationRequest: IPaginationRequest;
  formFields: FieldType[];
  rules: Rule[];
  onSearchChange: (search: string) => void;
  onRuleChange: (newRules: Rule[]) => void;
  isCampaign: boolean;
  isLoading: boolean;
  tags: string[];
  campaigns: ICampaignFormState[];
  groups: IGroup[];
  isFiltersLoading: boolean;
}

const defaultRules: Rule[] = [
  {
    filter: {
      command: "",
      field: "",
      type: "",
      value: "",
    },
    id: "initial-rule",
    rules: [],
  },
];

export default function DynamicSearchComponent({ props }: { props: DynamicSearchComponentProps }) {
  const [search, setSearch] = useState<string>(props.paginationRequest.search ?? "");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleSetRules = (newRules: Rule[]) => {
    props.onRuleChange(newRules);
  };

  const handleSetSearch = (newSearch: string) => {
    if (search !== newSearch) {
      setSearch(newSearch);
      props.onSearchChange(newSearch);
    }
  };

  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  const handleRemoveRule = (id: string) => {
    var newRules = [...props.rules];
    props.onRuleChange(newRules.filter((rule) => rule.id !== id));
  };

  const handleResetRules = () => {
    props.onRuleChange([]);
  };

  return (
    <Grid container gap={2}>
      <Grid item xs={12} md={4}>
        <CandidatesCapturedSearchInput
          dataTestId="candidates-searchbar"
          defaultSearch={search}
          handleSetSearch={handleSetSearch}
        />
      </Grid>
      <FilterModal
        queryRules={props.rules.length === 0 ? defaultRules : props.rules}
        formFields={props.formFields}
        isOpen={isFilterModalOpen}
        handleSetRules={handleSetRules}
        handleOpenModal={handleOpenFilterModal}
        handleCloseModal={handleCloseFilterModal}
        handleResetRules={handleResetRules}
        handleRemoveRule={handleRemoveRule}
        isCampaign={props.isCampaign}
        campaigns={props.campaigns}
        isLoading={props.isFiltersLoading}
        groups={props.groups}
        LoadSaveFilters={
          <CandidatesCapturedFilters
            isLoading={props.isLoading}
            rules={props.rules}
            handleSetRules={handleSetRules}
            campaignId={""}
          />
        }
        tags={props.tags}
      />
    </Grid>
  );
}
